export const AI_INPUT_PLACEHOLDER = "activation.setup.competitors.step.ai.input.placeholder";
export const AI_BUTTON_TEXT = "activation.setup.competitors.step.ai.input.button";
export const AI_BUTTON_TOOLTIP = "activation.setup.competitors.step.ai.input.button.tooltip";
